module.exports = __webpack_public_path__ + "img/nutrition_graph.ead73198.png";